<script setup lang="ts">
import RecipeManagement from "src/components/recipe-management/RecipeManagement.vue";
</script>

<template>
  <RecipeManagement />
</template>
